const manageGroupOptions = [
  {
    key: "OYAMA_ASHIKAGA",
    label: "小山制御所足利地域配電保守グループ",
    schemaNumbers: [2012500],
  },
  {
    key: "OTA_OTA",
    label: "太田制御所太田地域配電保守グループ",
    schemaNumbers: [2022600],
  },
  {
    key: "HITACHI",
    label: "水戸制御所日立地域配電保守グループ",
    schemaNumbers: [2032000],
  },
  {
    key: "MITO",
    label: "水戸制御所水戸地域配電保守グループ",
    schemaNumbers: [2032100, 2032200, 2033100],
  },
  {
    key: "SHIMODATE",
    label: "下館制御所配電保守グループ",
    schemaNumbers: [2032300, 2032900],
  },
  {
    key: "KASUKABE",
    label: "春日部制御所配電保守グループ",
    schemaNumbers: [2042200],
  },
  {
    key: "KAWAGOE",
    label: "川越制御所川越地域配電保守グループ",
    schemaNumbers: [2042800],
  },
  {
    key: "KAWAGOE_HANNO",
    label: "川越制御所飯能地域配電保守グループ",
    schemaNumbers: [2042900],
  },
  {
    key: "SHIKI_TOKOROZAWA",
    label: "志木制御所所沢地域配電保守グループ",
    schemaNumbers: [2043000],
  },
  {
    key: "SHIKI",
    label: "志木制御所志木地域配電保守グループ",
    schemaNumbers: [2043100],
  },
  {
    key: "CHIBA",
    label: "千葉制御所配電保守グループ",
    schemaNumbers: [2052000, 2053400],
  },
  {
    key: "FUNABASHI",
    label: "船橋制御所配電保守グループ",
    schemaNumbers: [2052100, 2052200, 2053500],
  },
  {
    key: "TOKATSU",
    label: "東葛制御所配電保守グループ",
    schemaNumbers: [2052300, 2052400, 2053300],
  },
  {
    key: "NARITA",
    label: "成田制御所配電保守グループ",
    schemaNumbers: [2052500, 2052600],
  },
  {
    key: "NARITA_CHOSHI",
    label: "成田制御所銚子地域配電保守グループ",
    schemaNumbers: [2052700],
  },
  {
    key: "NARITA_TOGANE",
    label: "成田制御所東金地域配電保守グループ",
    schemaNumbers: [2052800],
  },
  {
    key: "KISARAZU_MOBARA",
    label: "木更津制御所茂原地域配電保守グループ",
    schemaNumbers: [2052900, 2053000],
  },
  {
    key: "KISARAZU_TATEYAMA",
    label: "木更津制御所館山地域配電保守グループ",
    schemaNumbers: [2053100],
  },
  {
    key: "KISARAZU",
    label: "木更津制御所配電保守グループ",
    schemaNumbers: [2053200],
  },
  {
    key: "NUMAZU",
    label: "沼津制御所配電保守グループ",
    schemaNumbers: [2092000, 2092100, 2092200],
  },
  {
    key: "IZUKITA",
    label: "伊豆制御所伊豆北地域配電保守グループ",
    schemaNumbers: [2092300, 2092600],
  },
];

const manageGroupLabel = manageGroupOptions.reduce((acc, option) => {
  acc[option.key] = option.label;
  return acc;
}, {});

// const reportTagSort = [
//   "対象無し",
//   "位置ズレ",
//   "撮影困難",
//   "営巣",
//   "樹木",
//   "飛来物",
//   "番札",
//   "電柱銘板",
//   "電垂れ",
//   "電柱段差",
//   "電柱地際陥没",
//   "電柱足場ボルト受口",
//   "換気孔破損",
//   "換気孔段差",
//   "番号",
//   "落書き",
//   "錆",
//   "撮影危険",
//   "その他",
// ];

// TEPCO order
const reportTagSort = [
  "樹木",
  "営巣",
  "飛来物",
  "電垂れ",
  "電柱地際陥没",
  "電柱段差",
  "落書き",
  "錆",
  "その他",
  "番札",
  "番号",
  "換気孔破損",
  "換気孔段差",
  "撮影危険",
  "撮影困難",
  "位置ズレ",
  "対象無し",
  "電柱銘板",
  "電柱足場ボルト受口",
];

export default {
  manageGroupOptions,
  manageGroupLabel,
  reportTagSort,
};
